import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TokenPayload } from 'Interfaces/User';
import { rootActions } from 'Store';

interface InitDocumentSigning {
  (payload: TokenPayload): void;
}

interface FinishDocumentSigning {
  (): void;
}

export default () => {
  const dispatch = useDispatch();

  const initDocumentSigning: InitDocumentSigning = useCallback(
    (payload: TokenPayload) => {
      dispatch(rootActions.documentSign.initDocumentSigning(payload));
    },
    [dispatch],
  );

  const finishDocumentSigning: FinishDocumentSigning = useCallback(() => {
    dispatch(rootActions.documentSign.finishDocumentSigning());
  }, [dispatch]);

  return [initDocumentSigning, finishDocumentSigning] as const;
};
